/* unplugin-vue-components disabled */

export default {
  props: {
    valid: {type: Boolean, default: true},
    saving: {type: Boolean, default: false},
    saved_at: {type: Number, default: undefined}
  },
  data() {
    return {
      saved_ago: undefined,
      ago_timer: undefined
    }
  },
  watch: {
    saved_at() {
      this.formatAgo()
    }
  },

  mounted() {
    this.ago_timer = setInterval(() => this.formatAgo(), 1000)
  },
  unmounted() { 
    clearInterval(this.ago_timer)
    this.ago_timer = undefined
  },
  methods: {
    formatAgo() {
      this.saved_ago = this.saved_at ? $utils.format.daysAgo(this.saved_at) : ''
    }
  }
}
